export default "__VITE_ASSET__D$Gdmzvk__"